import React from 'react';
import {
  string, number, arrayOf, array, shape, bool,
} from 'prop-types';
import classnames from 'classnames';
import OrderLineField from '../OrderLineField';
import getOrderLineFieldsConfig from '../config/orderLinefieldConfig';

const OrderLineItem = ({
  primaryDescription,
  secondaryDescription,
  subDescription, unitPrice,
  price, // for omit it from rest
  quantity,
  orderLines,
  className,
  discounts,
  orderReviewHandleableConfig,
  identifier,
  pendingLine,
  isShowButtonCol,
  orderLineFieldsConfig,
  ...rest
}) => {
  const currentOrderLineFieldsConfig = orderLineFieldsConfig
  || getOrderLineFieldsConfig({
    orderReviewHandleableConfig,
    identifier,
    isShowButtonCol,
  });
  return (
    <div className={className} {...rest}>
      <OrderLineField
        title={primaryDescription}
        price={unitPrice}
        quantity={quantity}
        identifier={identifier}
        pendingLine={pendingLine}
        isShowButtonCol={isShowButtonCol}
        {...currentOrderLineFieldsConfig.primaryDescriptionFieldConfig}
        {...rest}
        className="primary-description"/>
      <div className={classnames({
        'additional-info-block': !!secondaryDescription || subDescription.length > 0 || discounts.length > 0,
      })}>
        <OrderLineField
          title={secondaryDescription}
          isShowButtonCol={isShowButtonCol}
          {...currentOrderLineFieldsConfig.secondaryDescriptionFieldConfig}
          className="secondary-description"/>
        { subDescription.length > 0
      && <div className={'sub-description-block'}>
        {
          subDescription.map((subDes, index) => {
            return (
              <OrderLineField
                key={index}
                title={subDes}
                isShowButtonCol={isShowButtonCol}
                {...currentOrderLineFieldsConfig.subDescriptionFieldConfig}
                className="sub-description"/>
            );
          })
        }
      </div>
        }
        { discounts.length > 0 && <div className="orderline-item__discount-block">
          {
            discounts.map(({ name, amount }, idx) => (
              <OrderLineField
                key={idx}
                title={name}
                price={amount}
                isShowButtonCol={isShowButtonCol}
                {...currentOrderLineFieldsConfig.discountFieldConfig}
                {...rest}
                className="orderline-item__discount"/>
            ))}
        </div>}
      </div>
      {
        orderLines && orderLines.map((subOrderLine, i) => {
          return (
            <React.Fragment key={i}>
              <OrderLineItem
                {...rest}
                {...subOrderLine}
                isShowButtonCol={isShowButtonCol}
                orderReviewHandleableConfig={orderReviewHandleableConfig}
                orderLineFieldsConfig={orderLineFieldsConfig}
                className="orderline-subItem"/>
            </React.Fragment>
          );
        })
      }
    </div>
  );
};

OrderLineItem.propTypes = {
  primaryDescription: string,
  secondaryDescription: string,
  subDescription: arrayOf(string),
  price: number,
  quantity: number,
  orderLines: array,
  currencyCode: string,
  className: string,
  discounts: arrayOf(shape({
    name: string,
    amount: number,
  })),
  orderReviewHandleableConfig: array,
  identifier: string,
  pendingLine: bool,
};

OrderLineItem.defaultProps = {
  primaryDescription: undefined,
  secondaryDescription: undefined,
  subDescription: [],
  price: undefined,
  quantity: undefined,
  orderLines: [],
  currencyCode: undefined,
  className: undefined,
  discounts: [],
  orderReviewHandleableConfig: [],
  pendingLine: false,
};

export default OrderLineItem;
